// Single source of truth for the public-site Services pages that the CMS
// can edit. The `key` doubles as the Firestore doc id under `pageSettings`
// (no collision with the listing-page keys `blogs` / `news` / `insights`).
//
// Add a new service here and it shows up automatically in /cms/services.
export const SERVICES = [
  {
    key: "tenant-representation",
    label: "Tenant Representation",
    path: "/tenant-representation",
    defaultHeading: "Tenant Representation",
    description: "Helping occupiers find and secure the right space.",
  },
  {
    key: "landlord-representation",
    label: "Landlord Representation",
    path: "/landlord-representation",
    defaultHeading: "Landlord Representation",
    description: "Maximizing value for property owners.",
  },
  {
    key: "investment-sales",
    label: "Investment Sales",
    path: "/investment-sales",
    defaultHeading: "Investment Sales",
    description: "Institutional and high-value transactions.",
  },
  {
    key: "research-consultancy",
    label: "Research & Consultancy",
    path: "/research-consultancy",
    defaultHeading: "Research & Consultancy",
    description: "Market intelligence, analysis, and advisory.",
  },
  {
    key: "hotels-tourism-leisure",
    label: "Hotels, Tourism & Leisure",
    path: "/hotels-tourism-leisure",
    defaultHeading: "Hotels, Tourism & Leisure",
    description: "Hospitality and resort property advisory.",
  },
  {
    key: "residential-sales-leasing",
    label: "Residential Sales & Leasing",
    path: "/residential-sales-leasing",
    defaultHeading: "Residential Sales & Leasing",
    description: "Residential property transactions.",
  },
  {
    key: "valuation-property-appraisal",
    label: "Valuation & Property Appraisal",
    path: "/valuation-property-appraisal",
    defaultHeading: "Valuation & Property Appraisal",
    description: "Independent property valuations.",
  },
];

export function getServiceByKey(key) {
  return SERVICES.find((s) => s.key === key);
}
